import { useEffect, useState } from 'react';

import { useCompanyApi } from '@lendica/hooks';
import { Approval, RateCurve, ProductName } from '@lendica/utils';
import { v2 } from '@lendica/api';

export const useApprovalSummaryV2 = (product?: ProductName | string, page = 1, pageSize = 50) => {
    const api = useCompanyApi();
    const [data, setData] = useState<(Approval & { rateCurve: RateCurve[] })[] | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<unknown>(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                // TODO: is /approvals/list paginated or not??
                let activeApprovals = await api.get<v2.PaginatedResponse<Approval>>(
                    `/approvals/list?active=true&page=${page}&page_size=${pageSize}${
                        product ? `&product_name=${product}` : ''
                    }`
                );
                // if (product)
                //     activeApprovals = activeApprovals.filter(a => a.product_name === product);
                if (!activeApprovals.count || !activeApprovals.results.length) return setData(null);
                const approvalDetails = await Promise.all(
                    activeApprovals.results.map(async a => {
                        return await api.get<Approval>(`/approvals/detail?approval_id=${a.id}`);
                    })
                );
                const rateCurves = await api.get<RateCurve[]>('/ratecurve_backbones/detail');
                const result = approvalDetails.map(a => {
                    const rcs = rateCurves.filter(r => r.approval === a.id);
                    return { ...a, rateCurve: rcs.sort((x, y) => x.day - y.day) };
                });
                if (!cancelled) setData(result);
            } catch (e) {
                if (!cancelled) setError(e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [api, product, page, pageSize]);

    return { data, loading, error };
};
